import { FormGroup } from '@angular/forms';

export function customerIdValidator(key: string) {
  return (group: FormGroup): {
    [key: string]: any
  } => {
    if (!group || !group.controls) {
      return { mismatched: false };
    }

    const value = group.controls[key].value;
    const pattern = /[0-9]{4}-[0-9]{5}/;

    if (!pattern.test(value)) {
      return {
        mismatched: true
      };
    }
  };
}
